/* jshint esversion: 6 */

const Utils = {
    genTypes: (model, group) => Object.keys(model).reduce((prev, key) => {
        prev[key] = `${group}.${key}`;
        return prev;
    }, {}),
    genState: (model, group) => Object.keys(model).reduce((prev, key) => {
        prev[`${group}.${key}`] = model[key];

        return prev;
    }, {}),
    genGetters: types => Object.values(types).reduce((prev, value) => {
        prev[value] = state => state[value];
        return prev;
    }, {}),
    genMutations: types => Object.values(types).reduce((prev, value) => {
        prev[value] = (state, payload) => { state[value] = payload; };
        return prev;
    }, {})
};

export default Utils;